import { render, staticRenderFns } from "./Indumentarias.vue?vue&type=template&id=31856ee6"
import script from "./Indumentarias.vue?vue&type=script&lang=js"
export * from "./Indumentarias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports